module.exports = __webpack_public_path__ + "static/media/imobile.e746e7ec.jpeg";